import jwtDecode, { JwtPayload } from 'jwt-decode';
import moment, {Moment} from 'moment';

export const isTokenValid = (token: string): boolean => {
    const decoded = jwtDecode<JwtPayload>(token);

    if(!decoded.exp){
        return false;
    }
    const expTime: Moment = moment(decoded.exp);
    return !expTime.isValid() || expTime.isBefore(moment());
}